import { useCallback } from 'react';

import { useOrders } from '../../../hooks/useOrders';

import './orders.scss';

import { getOrderColumnDefinition } from '../../../schema/order/order.schema';
import { EntityTable } from '../../common/entity-table/EntityTable';
import Navigation from '../../navigation/Navigation';

const Orders = () => {
  const { orders, deliveryDetails, loadingDelivery } = useOrders();

  const getColumnDefinition = useCallback(
    () => getOrderColumnDefinition(loadingDelivery, deliveryDetails),
    [loadingDelivery, deliveryDetails]
  );

  return (
    <Navigation>
      <div className="orders">
        <h1>Orders</h1>
        <span>
          DISCLAIMER: Please note that the estimated delivery time is subject to change due to
          external factors such as traffic, weather, and courier availability.
        </span>
        <div>
          <EntityTable
            query={{ data: orders, loading: false }}
            getColumnDefinition={getColumnDefinition}
            entityTabs={[]}
            entityName="Menu"
            canExport={false}
            canView={false}
            canEdit={false}
            showAction={false}
            canDelete={false}
            single
          />
        </div>
      </div>
    </Navigation>
  );
};

export default Orders;
